export default {"src":"/_next/static/media/WalletApp.7e028c1a.svg","height":49,"width":48,"blurWidth":0,"blurHeight":0};